// import MELCIcon from "@mui/icons-material/ListAlt";
import DataIcon from "@mui/icons-material/Description";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import BusinessIcon from "@mui/icons-material/Business";
import GroupIcon from "@mui/icons-material/Group";

const links = [
  {
    title: "Data",
    role: "superadmin",
    links: [
      {
        name: "Feedbacks",
        path: "admin",
        icon: <DataIcon />,
      },
    ],
  },

  {
    title: "Services",
    role: "superadmin",
    links: [
      {
        name: "Services",
        path: "service",
        icon: <ManageAccountsIcon />,
      },
    ],
  },

  {
    title: "Offices",
    role: "superadmin",
    links: [
      {
        name: "Offices",
        path: "office",
        icon: <BusinessIcon />,
      },
    ],
  },
  {
    title: "Offices",
    role: "superadmin",
    links: [
      {
        name: "Users",
        path: "users",
        icon: <GroupIcon />,
      },
    ],
  },
];

export default links;
